/**
 * Репозиторий сущности «Лекарство».
 * CRUD, мягкое удаление и запись в очередь синхронизации — в базовой фабрике
 * (`src/shared/db/repository.ts`). Здесь только специфичные запросы.
 */

import { db } from '@/shared/db/database';
import { createRepository } from '@/shared/db/repository';
import type { Medication } from '@/shared/db/schema';

export const medicationsRepo = createRepository<Medication>('medications', db.medications);
